export type KioskAlertSeverity = 'critical' | 'warning' | 'info';
export type KioskAlertStatus = 'open' | 'handled' | 'cleared';
export type KioskAlertAudience = 'site' | 'platform';

export const KIOSK_ALERT_STATUSES: KioskAlertStatus[] = ['open', 'handled', 'cleared'];

export interface KioskAlert {
  id: string;
  kind: string;
  label: string;
  severity: KioskAlertSeverity;
  audience: KioskAlertAudience;
  selfClearing: boolean;
  summary: string;
  kioskId: string;
  kioskName: string;
  siteId: string;
  siteName: string;
  status: KioskAlertStatus;
  details: Record<string, unknown>;
  raisedAt: string;
  notifiedAt: string | null;
  clearedAt: string | null;
  handledAt: string | null;
  handledBy: string | null;
  handledByName: string | null;
  handledNote: string | null;
}

export interface KioskAlertSummary {
  openTotal: number;
  byKiosk: Record<string, number>;
}

export interface KioskAlertKindOption {
  kind: string;
  label: string;
  severity: KioskAlertSeverity;
  audience: KioskAlertAudience;
}
